module.exports = __webpack_public_path__ + "static/media/manual_placements_manage_supervisors.a6da634a.mov";